import React, {useEffect, useState} from 'react';
import Template from "../../layouts/Template";
import './index.scss';
import {useAppDispatch, useAppSelector} from "../../states/hooks";
import CurrentDevice from "../../components/CurrentDevice";
import smsDevice from "../../utils/smsDevice";
import {Button, DialogActions, DialogTitle} from "@mui/material";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogAlarmSos from "../../components/DialogAlarmSos";
import DialogAlarmSpeed from "../../components/DialogAlarmSpeed";
import DialogAlarmDistance from "../../components/DialogAlarmDistance";
import {tableNames} from "../../database/interfaceDb";
import helpers from "../../utils/helpers";
import IndexedDb from "../../database/indexedDb";
import {deviceState} from "../../states/deviceState";

//**********************************************************

let _distance: number;
let indexedDb: IndexedDb;
let myDeviceState: any = { ...deviceState.getInitialState() };

//**********************************************************

function Index()
{
    const dispatch = useAppDispatch();
    const currentDeviceState = useAppSelector(state => state.deviceState);
    
    const [dialogCallSmsTitle, setDialogCallSmsTitle] = useState('');
    const [dialogCallSmsCode, setDialogCallSmsCode] = useState(null);
    const [dialogCallSmsIsOpen, setDialogCallSmsIsOpen] = useState(false);
    
    const dialogAlarmSpeed = React.createRef<any>();
    const [dialogAlarmSpeedMobileNumber, setDialogAlarmSpeedMobileNumber] = useState<string>('');
    const [dialogAlarmSpeedCode, setDialogAlarmSpeedCode] = useState<string>('');

    const dialogAlarmSos = React.createRef<any>();
    const [dialogAlarmSosMobileNumber, setDialogAlarmSosMobileNumber] = useState<string>('');
    const [dialogAlarmSosCode, setDialogAlarmSosCode] = useState<string>('');

    const [myCurrentDeviceState, setMyCurrentDeviceState] = useState<any>(myDeviceState);

    const dialogAlarmMoving = React.createRef<any>();

    // open db
    const initDB = () =>
    {
        indexedDb = new IndexedDb();
        indexedDb.open().then
        (
            r =>
            {
                // load data
                deviceLoadData();
            }
        );
    };
    useEffect(() => { initDB(); }, [currentDeviceState]);

    // load data
    const deviceLoadData = () =>
    {
        indexedDb.getAllValue(tableNames.Devices).then
        (
            data =>
            {
                for(let device of data)
                {
                    if(device.selected === 1)
                    {
                        setMyCurrentDeviceState(device);
                        myDeviceState = device;

                        break;
                    }
                }
            }
        );
    };
    
    //
    const handleAlarmSpeed = (smsBody:string) =>
    {
        setDialogAlarmSpeedMobileNumber(currentDeviceState.mobile);
        setDialogAlarmSpeedCode(smsBody);
        dialogAlarmSpeed.current.show();
    }
    
    const handleAlarmSos = (smsBody:string) =>
    {
        setDialogAlarmSosMobileNumber(currentDeviceState.mobile);
        setDialogAlarmSosCode(smsBody);
        dialogAlarmSos.current.show();
    }
    
    const handleAlarmMoving = () =>
    {
        dialogAlarmMoving.current.show();
    }
    
    const handleAlarmMovingCallback = (distance:number) =>
    {
        // let code =
        //     {
        //         on: smsDevice.Concox.alarmMoving.code.on.replace('Distance', distance.toString()),
        //         on2: smsDevice.Concox.alarmMoving.code.on2.replace('Distance', distance.toString())
        //     }
        //
        // handleDialogCallSmsOpen(smsDevice.Concox.alarmMoving.title, code);
        let code =
            {
                on: smsDevice.Concox.alarmMoving.code.on.replace('Distance', distance.toString()),
                on2: smsDevice.Concox.alarmMoving.code.on2.replace('Distance', distance.toString()),
                off: smsDevice.Concox.alarmMoving.code.off
            }

        _distance = distance;
        handleDialogCallSmsOpen(smsDevice.Concox.alarmMoving.title, code);
    }
    
    // call sms
    const handleDialogCallSmsOpen = (title:string, smsCode:any) =>
    {
        setDialogCallSmsTitle(title);
        setDialogCallSmsCode(smsCode);
        setDialogCallSmsIsOpen(true);
    };
    
    const handleDialogCallSmsClose = () =>
    {
        setDialogCallSmsIsOpen(false);
    };
    
    const handleDialogCallSms = (type: number) =>
    {
        if(type === 1)
        {
            // @ts-ignore
            helpers.sendSms(currentDeviceState.mobile, dialogCallSmsCode.on);
            // @ts-ignore
            // window.open("sms:" + currentDeviceState.mobile + "?&body=" + dialogCallSmsCode.on);
        }
        else
        {
            // @ts-ignore
            helpers.sendSms(currentDeviceState.mobile, dialogCallSmsCode.on2);
            // @ts-ignore
            // window.open("sms:" + currentDeviceState.mobile + "?&body=" + dialogCallSmsCode.on2);
        }

        // @ts-ignore
        switch(dialogCallSmsCode.off)
        {
            case smsDevice.Concox.alarmTurnOff.code.off: myDeviceState.concoxAlarmTurnOff = 'on'; break;
            case smsDevice.Concox.alarmTurnOn.code.off: myDeviceState.concoxAlarmTurnOn = 'on'; break;
            case smsDevice.Concox.alarmDoor.code.off: myDeviceState.concoxAlarmDoor = 'on'; break;
            case smsDevice.Concox.alarmImpact.code.off: myDeviceState.concoxAlarmImpact = 'on'; break;
            case smsDevice.Concox.alarmMoving.code.off: myDeviceState.concoxAlarmMoving = _distance; break;
        }
        handleDeviceDataSave();
        
        handleDialogCallSmsClose();
    };

    const handleDeviceDataSave = () =>
    {
        indexedDb.putValue(tableNames.Devices, {...myDeviceState}).then
        (
            value =>
            {
                dispatch(deviceState.actions.save({...myDeviceState}));
            }
        );
    };

    // btns
    const handleConcoxTurnOff = (type: number) =>
    {
        let code = '';

        if(type === 0)
        {
            myDeviceState.concoxTurnOff = 'off';
            code = smsDevice.Concox.turnOff.code.off;
        }
        else
        {
            myDeviceState.concoxTurnOff = 'on';
            code = smsDevice.Concox.turnOff.code.on;
        }

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }

    const handleConcoxAlarmSpeed = (type: number) =>
    {
        if(type === 0)
        {
            myDeviceState.concoxAlarmSpeed = 'off';
            handleDeviceDataSave();

            helpers.sendSms(myCurrentDeviceState.mobile, smsDevice.Concox.alarmSpeed.code.off);
        }
        else
        {
            handleAlarmSpeed(smsDevice.Concox.alarmSpeed.code.on);
        }
    }
    const callbackConcoxAlarmSpeed = (speed: number) =>
    {
        myDeviceState.concoxAlarmSpeed = speed;
        handleDeviceDataSave();
    }

    const handleAlarmDisconnectBattery = (type: number) =>
    {
        let code = '';

        if(type === 0)
        {
            myDeviceState.concoxAlarmDisconnectBattery = 'off';
            code = smsDevice.Concox.alarmDisconnectBattery.code.off;
        }
        else
        {
            myDeviceState.concoxAlarmDisconnectBattery = 'on';
            code = smsDevice.Concox.alarmDisconnectBattery.code.on;
        }

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }

    const handleConcoxAlarmDoor = (type: number) =>
    {
        if(type === 0)
        {
            myDeviceState.concoxAlarmDoor = 'off';
            handleDeviceDataSave();

            helpers.sendSms(myCurrentDeviceState.mobile, smsDevice.Concox.alarmDoor.code.off);
        }
        else
        {
            handleDialogCallSmsOpen(smsDevice.Concox.alarmDoor.title, smsDevice.Concox.alarmDoor.code);
        }
    }

    const handleConcoxAlarmImpact = (type: number) =>
    {
        if(type === 0)
        {
            myDeviceState.concoxAlarmImpact = 'off';
            handleDeviceDataSave();

            helpers.sendSms(myCurrentDeviceState.mobile, smsDevice.Concox.alarmImpact.code.off);
        }
        else
        {
            handleDialogCallSmsOpen(smsDevice.Concox.alarmImpact.title, smsDevice.Concox.alarmImpact.code);
        }
    }

    const handleConcoxAlarmMoving = (type: number) =>
    {
        if(type === 0)
        {
            myDeviceState.concoxAlarmMoving = 'off';
            handleDeviceDataSave();

            helpers.sendSms(myCurrentDeviceState.mobile, smsDevice.Concox.alarmMoving.code.off);
        }
        else
        {
            handleAlarmMoving();
        }
    }

    const handleConcoxAlarmTurnOn = (type: number) =>
    {
        if(type === 0)
        {
            myDeviceState.concoxAlarmTurnOn = 'off';
            handleDeviceDataSave();

            helpers.sendSms(myCurrentDeviceState.mobile, smsDevice.Concox.alarmTurnOn.code.off);
        }
        else
        {
            handleDialogCallSmsOpen(smsDevice.Concox.alarmTurnOn.title, smsDevice.Concox.alarmTurnOn.code);
        }
    }

    const handleConcoxAlarmTurnOff = (type: number) =>
    {
        if(type === 0)
        {
            myDeviceState.concoxAlarmTurnOff = 'off';
            handleDeviceDataSave();

            helpers.sendSms(myCurrentDeviceState.mobile, smsDevice.Concox.alarmTurnOff.code.off);
        }
        else
        {
            handleDialogCallSmsOpen(smsDevice.Concox.alarmTurnOff.title, smsDevice.Concox.alarmTurnOff.code);
        }
    }

    const handleCobanTurnOff = (type: number) =>
    {
        let code = '';

        if(type === 0)
        {
            myDeviceState.cobanTurnOff = 'off';
            code = smsDevice.Coban.turnOff.code.off;
        }
        else
        {
            myDeviceState.cobanTurnOff = 'on';
            code = smsDevice.Coban.turnOff.code.on;
        }

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }

    const handleCobanAlarmSpeed = (type: number) =>
    {
        if(type === 0)
        {
            myDeviceState.cobanAlarmSpeed = 'off';
            handleDeviceDataSave();

            helpers.sendSms(myCurrentDeviceState.mobile, smsDevice.Coban.alarmSpeed.code.off);
        }
        else
        {
            handleAlarmSpeed(smsDevice.Coban.alarmSpeed.code.on);
        }
    }
    const callbackCobanAlarmSpeed = (speed: number) =>
    {
        myDeviceState.cobanAlarmSpeed = speed;
        handleDeviceDataSave();
    }

    const handleCobanAlarmMoving = (type: number) =>
    {
        let code = '';

        if(type === 0)
        {
            myDeviceState.cobanAlarmMoving = 'off';
            code = smsDevice.Coban.alarmMoving.code.off;
        }
        else
        {
            myDeviceState.cobanAlarmMoving = 'on';
            code = smsDevice.Coban.alarmMoving.code.on;
        }

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }

    const handleCobanAlarmTurnOn = (type: number) =>
    {
        let code = '';

        if(type === 0)
        {
            myDeviceState.cobanAlarmTurnOn = 'off';
            code = smsDevice.Coban.alarmTurnOn.code.off;
        }
        else
        {
            myDeviceState.cobanAlarmTurnOn = 'on';
            code = smsDevice.Coban.alarmTurnOn.code.on;
        }

        handleDeviceDataSave();
        helpers.sendSms(myCurrentDeviceState.mobile, code);
    }

    const callbackCobanAlarmSOS = (mobile: string) =>
    {
        myDeviceState.cobanAlarmSOS = mobile;
        handleDeviceDataSave();
    }
    
    //--------------------
    return (
        <Template pageClass="page-sms" pageTitle="دستورات">
            <CurrentDevice />
            
            <div className="btn-codes">
                {
                    {
                        'Concox': <>
                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.concoxTurnOff === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleConcoxTurnOff(1)} className="btn-on">On</span>
                                    <span onClick={() => handleConcoxTurnOff(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.turnOff.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (helpers.isNumeric(myCurrentDeviceState.concoxAlarmSpeed) ? 'on' : 'off')}>
                                    <span onClick={() => handleConcoxAlarmSpeed(1)} className="btn-on">On</span>
                                    <span onClick={() => handleConcoxAlarmSpeed(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.alarmSpeed.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.concoxAlarmDoor === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleConcoxAlarmDoor(1)} className="btn-on">On</span>
                                    <span onClick={() => handleConcoxAlarmDoor(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.alarmDoor.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.concoxAlarmDisconnectBattery === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleAlarmDisconnectBattery(1)} className="btn-on">On</span>
                                    <span onClick={() => handleAlarmDisconnectBattery(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.alarmDisconnectBattery.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.concoxAlarmImpact === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleConcoxAlarmImpact(1)} className="btn-on">On</span>
                                    <span onClick={() => handleConcoxAlarmImpact(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.alarmImpact.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (helpers.isNumeric(myCurrentDeviceState.concoxAlarmMoving) ? 'on' : 'off')}>
                                    <span onClick={() => handleConcoxAlarmMoving(1)} className="btn-on">On</span>
                                    <span onClick={() => handleConcoxAlarmMoving(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.alarmMoving.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.concoxAlarmTurnOn === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleConcoxAlarmTurnOn(1)} className="btn-on">On</span>
                                    <span onClick={() => handleConcoxAlarmTurnOn(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.alarmTurnOn.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.concoxAlarmTurnOff === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleConcoxAlarmTurnOff(1)} className="btn-on">On</span>
                                    <span onClick={() => handleConcoxAlarmTurnOff(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Concox.alarmTurnOff.title}</div>
                            </div>
                        </>,

                        'Coban': <>
                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.cobanTurnOff === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleCobanTurnOff(1)} className="btn-on">On</span>
                                    <span onClick={() => handleCobanTurnOff(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Coban.turnOff.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (helpers.isNumeric(myCurrentDeviceState.cobanAlarmSpeed) ? 'on' : 'off')}>
                                    <span onClick={() => handleCobanAlarmSpeed(1)} className="btn-on">On</span>
                                    <span onClick={() => handleCobanAlarmSpeed(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Coban.alarmSpeed.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.cobanAlarmMoving === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleCobanAlarmMoving(1)} className="btn-on">On</span>
                                    <span onClick={() => handleCobanAlarmMoving(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Coban.alarmMoving.title}</div>
                            </div>

                            <div className="code-box">
                                <div className={"btn-box " + (myCurrentDeviceState.cobanAlarmTurnOn === 'on' ? 'on' : 'off')}>
                                    <span onClick={() => handleCobanAlarmTurnOn(1)} className="btn-on">On</span>
                                    <span onClick={() => handleCobanAlarmTurnOn(0)} className="btn-off">Off</span>
                                </div>
                                <div className="title">{smsDevice.Coban.alarmTurnOn.title}</div>
                            </div>
                            
                            <div className="code-box">
                                <div className="btn-box">
                                    <span onClick={() => handleAlarmSos(smsDevice.Coban.alarmSOS.code)} className="btn-single">SOS</span>
                                </div>
                                <div className="title">{smsDevice.Coban.alarmSOS.title}</div>
                            </div>
                        </>,
                    }
                        [currentDeviceState.deviceType]
                }
            </div>

            {/* modal get max speed */}
            <DialogAlarmSpeed ref={dialogAlarmSpeed} mobileNumber={dialogAlarmSpeedMobileNumber} smsCode={dialogAlarmSpeedCode} lastSpeed={currentDeviceState.deviceType === 'Concox' ? myCurrentDeviceState.concoxAlarmSpeed : myCurrentDeviceState.cobanAlarmSpeed} callback={currentDeviceState.deviceType === 'Concox' ? callbackConcoxAlarmSpeed : callbackCobanAlarmSpeed} />

            {/* modal get sos mobile */}
            <DialogAlarmSos ref={dialogAlarmSos} mobileNumber={dialogAlarmSosMobileNumber} smsCode={dialogAlarmSosCode} mobileSos={myCurrentDeviceState.cobanAlarmSOS} callback={callbackCobanAlarmSOS} />

            {/* modal get distance */}
            <DialogAlarmDistance ref={dialogAlarmMoving} callback={handleAlarmMovingCallback} distance={myCurrentDeviceState.concoxAlarmMoving} />

            {/* modal call sms */}
            <Dialog open={dialogCallSmsIsOpen} onClose={handleDialogCallSmsClose}>
                <DialogTitle>{dialogCallSmsTitle}</DialogTitle>
                
                <DialogContent>یک گزینه را انتخاب نمایید.</DialogContent>
                
                <DialogActions>
                    <Button size="medium" variant="outlined" onClick={handleDialogCallSmsClose}>لغو</Button>
                    <Button size="medium" variant="contained" color="primary" onClick={() => handleDialogCallSms(2)}>پیامک و تماس</Button>
                    <Button size="medium" variant="contained" color="secondary" onClick={() => handleDialogCallSms(1)}>پیامک</Button>
                </DialogActions>
            </Dialog>
        </Template>
    );
}

export default Index;
